export const NOT_REQUIRED_STEP_NUMBER = 0;
export const PENDING_STEP_NUMBER = 1;
export const SIGNED_STEP_NUMBER = 2;



// WEBPACK FOOTER //
// ./src/constants/signatureStatuses.js